import { FILE } from '../constants';
import { FileElement } from '../types';

/** Create a wrex file element object. */
export const createFile = (attributes: Omit<FileElement, 'children' | 'type'>): FileElement => {
    return { ...attributes, type: FILE, children: [{ text: '' }] };
};
